import styled from "styled-components";

import { ContentContainer } from "./styles";

interface Props {
  children: React.ReactNode;
  header: string;
  headerContent?: React.ReactNode;
}

export const FormPageContainer: React.FC<Props> = ({ children, header, headerContent }) => {
  return (
    <ContentContainer>
      <Header>
        <Heading>{header}</Heading>
        {headerContent}
      </Header>

      {children}
    </ContentContainer>
  );
};

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Heading = styled.h3`
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.1px;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;
